<div style="width: 100%" [ngClass]="cls" class="app-input">
  <mat-form-field style="width: 100%" floatLabel="always">
    <mat-label>{{ label }}</mat-label>
    <!--[placeholder]="label"-->
    <input
      matInput
      [formControl]="inputControl"
      [required]="_required"
      [name]="name"
      [type]="_type"
      [readonly]="_disabled"
      [errorStateMatcher]="errorSM"
      [placeholder]="placeholder"
      [attr.list]="dlId"
      (focusout)="focout($event)"
      [readonly]="readonly"
      #ic
    />

    <button
      mat-icon-button
      *ngIf="isPasswordField"
      matSuffix
      (click)="changePasswordInput()"
      style="padding: 2px"
    >
      <mat-icon *ngIf="_type === 'text'" class="password-icon"
        >visibility_off</mat-icon
      >
      <mat-icon *ngIf="_type === 'password'" class="password-icon"
        >visibility</mat-icon
      >
    </button>
    <span *ngIf="suffix" matSuffix>{{ suffix }}</span>
    <datalist [id]="dlId">
      <option *ngFor="let d of datalist">{{ d }}</option>
    </datalist>
    <mat-error *ngIf="hasMaxLengthError"> Eingabetext ist zu lang </mat-error>
    <mat-error *ngIf="error">{{error}}aa</mat-error>
  </mat-form-field>
</div>
